import AccessKeyManager from '@alme/ui-web/ref/accesskey';
import LanguageManager from '@alme/ui-web/ref/language';
import ChannelManager from '@alme/ui-web/ref/channel';
import SessionManager from '@alme/ui-web/ref/session';
import UserManager from '@alme/ui-web/ref/user';
import PageAwareness from '@alme/ui-web/ref/pageawareness';
import RequestProcessorEndSession from '@alme/ui-web/ref/request-processor-end-session';
import UiVersionNumberRequestProcessor from '@alme/ui-web/ref/request-processor-ui-version-number';
import MarkdownResponseHandler from '@alme/ui-web/ref/response-handler-markdown';
import CommandActionHandler from '@alme/ui-web/ref/command-action-handler';
import { ResponseHandlerInlineSurveyLinks } from '@alme/ui-web/ref/message-renderer-inline-survey-links';
import { settings } from '@alme/ui-web/settings/settings-util';
import AnalyticsResponseHandler from '../components/response-handlers/nextit-response-handler-analytics-amtrak';
import ResponseUrlConverter from '../components/response-handlers/nextit-response-url-converter';
import FormInteractionResponseHandler from '../components/response-handlers/form-interaction/response-handler-form-interaction';
import BookingFlowResponseHandler from '../components/response-handlers/booking-flow/booking-flow';
import UserLogginRequestHandler from '../components/request-processor-user-loggedin-session/src/request-processor-user-loggedin-session';
import CallToActionResponseHandler from '@alme/ui-web/modules/message-renderer-call-to-action/src/response-handler-call-to-action';

let inputRequestProcessors, responseHandlers;

function setupInputRequestProcessors(components) {
    components.accessKeyManagerRequestProcessor = components.accessKeyManager.getRequestProcessor();
    components.languageManagerRequestProcessor = components.languageManager.getRequestProcessor();
    components.channelManagerRequestProcessor = components.channelManager.getRequestProcessor();
    components.sessionManagerRequestProcessor = components.sessionManager.getRequestProcessor();
    components.userManagerRequestProcessor = components.userManager.getRequestProcessor();
    components.pageAwarenessRequestProcessor = components.pageAwareness.getRequestProcessor();
    components.endSessionRequestProcessor = new RequestProcessorEndSession(null);
    components.uiVersionNumberRequestProcessor = new UiVersionNumberRequestProcessor();
    inputRequestProcessors = [
        components.inputboxLockMutator.getRequestProcessor(),
        components.accessKeyManagerRequestProcessor,
        components.languageManagerRequestProcessor,
        components.channelManagerRequestProcessor,
        components.sessionManagerRequestProcessor,
        components.userManagerRequestProcessor,
        components.pageAwarenessRequestProcessor,
        components.endSessionRequestProcessor,
        components.uiVersionNumberRequestProcessor,
        components.loggedinRequestProcessor,
    ];
}

function setupResponseHandlers(components) {
    components.commandActionHandler = new CommandActionHandler();
    components.getHistoryResponseHandler = components.initializeGetHistory.getResponseHandler();
    components.userManagerResponseHandler = components.userManager.getResponseHandler();
    components.getHistoryWatcherResponseHandler = components.historyWatcher.getResponseHandler();
    components.markdownProcessor = new MarkdownResponseHandler(null, components.displayLinkRenderer);
    components.inlineSurveyLinksResponseHandler = new ResponseHandlerInlineSurveyLinks();
    components.callToActionResponseHandler = new CallToActionResponseHandler(settings, components.singleLinkRenderer);

    // Custom
    components.analyticsHandler = new AnalyticsResponseHandler(settings);
    components.responseUrlConverter = new ResponseUrlConverter(settings);
    components.formInteractionHandler = new FormInteractionResponseHandler(settings);
    components.bookingFlowResponseHandler = new BookingFlowResponseHandler(settings);

    responseHandlers = [
        components.inputboxLockMutator.getResponseHandler(),
        components.markdownProcessor.getResponseHandler(),
        components.getHistoryWatcherResponseHandler,
        components.userManagerResponseHandler,
        components.commandActionHandler,
        components.inlineSurveyLinksResponseHandler,
        components.analyticsHandler,
        components.responseUrlConverter,       
        components.formInteractionHandler,
        components.bookingFlowResponseHandler,
        components.callToActionResponseHandler,
        components.liveChatFoundation.GetHistoryResponseHandler,
        components.liveChatFoundation.ResponseHandler,
        components.liveChatFoundation.ErrorResponseHandler,
        components.initializeGetConfiguration,
    ];
}

function setupConversation(components, conversation) {

    //modules that have more than one component
    components.accessKeyManager = new AccessKeyManager();
    components.languageManager = new LanguageManager();
    components.channelManager = new ChannelManager();
    components.sessionManager = new SessionManager();
    components.userManager = new UserManager();
    components.pageAwareness = new PageAwareness();

    //custom
    components.loggedinRequestProcessor = new UserLogginRequestHandler().getRequestProcessor();

    setupInputRequestProcessors(components);
    setupResponseHandlers(components);
    conversation.setInputRequestProcessors(inputRequestProcessors);
    conversation.setResponseHandlers(responseHandlers);

    return components;
}

export {
    setupConversation,
    inputRequestProcessors,
    responseHandlers
};



// WEBPACK FOOTER //
// ./src/setup-conversation-components.js